/* eslint-disable no-useless-escape */
import * as Yup from 'yup';
import i18n from 'i18n';

export default Yup.object().shape({
  operator_name: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  disconnection_time: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  notification_email: Yup.mixed().when('isArray', {
    is: Array.isArray,
    then: Yup.array().of(Yup.string()),
    otherwise: Yup.string(),
  }),
  user_message: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
